import React from 'react'
import {mapServiceTypeToTitle,} from "../constants";
import ProgressTrackerBar from "../components/ProgressTrackerBar";
import ProgressTrackerRowsBroadband from "../components/ProgressTrackerRowsBroadband";

const PendingConnectionBroadbandV2 = ({ serviceDetails, status }) => {

    return (
        <div className='pending-connection-v2'>
            <div className="flex">
                <div className="left mr-4">
                    <img src="/images/pending-broadband-connection.jpg" alt="Pending connection" className="d-none d-lg-block" />
                    <div className="inner">
                        <h3 className="m-0 mb-3 bold">New broadband service</h3>
                        <ul className="m-0 p-0 lh">
                            <li><span className="bold">Service address</span><br />{serviceDetails.address}</li>
                            <li><span className="bold">Service type</span><br /><span dangerouslySetInnerHTML={{__html: mapServiceTypeToTitle[serviceDetails.type]}} /></li>
                            <li><span className="bold">Plan name</span><br />{serviceDetails.planTitle ? serviceDetails.planTitle : serviceDetails.speedTier}</li>
                        </ul>
                    </div>
                </div>
                <div className="right">
                    <h3 className="m-0 mb-3 bold">Progress tracker</h3>
                    <ProgressTrackerBar data={status} />
                    <div className="mt-5">
                        <ProgressTrackerRowsBroadband
                            data={status}
                            serviceDetails={serviceDetails}
                        />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default PendingConnectionBroadbandV2



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnectionBroadbandV2.js